<evc-modal [showCloseButton]="false" [showReduceButton]="false" [showBackdrop]="false" [width]="'640px'" [height]="'640px'" (closeModal)="close()">
  <div class="main-container" modal-content>
    <h2>{{ "thirdPartyNoticeDialog.title" | translate }}</h2>

    <div class="license-content-area">
      <iframe class="license-iframe" frameborder="0" style="border: none" src="assets/ThirdPartyNotice.txt"></iframe>
    </div>

    <div class="license-btn">
      <evc-nav-button type="tertiary" (click)="close()">{{ "thirdPartyNoticeDialog.close" | translate }}</evc-nav-button>
    </div>
  </div>
</evc-modal>
